import React from 'react';

import { Text } from '@/components/shared/element/text';
import { Grid } from '@/components/shared/layout/grid';

interface DealerPanelContentAddressProps {
  label: string;
  address: string;
}

export const DealerPanelContentAddress: React.FunctionComponent<
  DealerPanelContentAddressProps
> = (props: DealerPanelContentAddressProps) => {
  return (
    <Grid
      columnGap={{ '@initial': '4', '@xs': '6' }}
      css={{ gridTemplateColumns: '30px auto' }}
    >
      <Text as="h4" size="text-base" font="bold" variant="text-gray">
        {props.label}
      </Text>
      <Text as="p">{props.address}</Text>
    </Grid>
  );
};

DealerPanelContentAddress.displayName = 'SectionDealerPanelContentAddress';
